import {preload} from 'react-dom'

const s3baseUrl = 'https://my-beauty-pa-poc-looks-assets.s3.ap-southeast-2.amazonaws.com'
const asImage = {as: 'image'}

export const preloadResources = {
  splash: () => {
    preload(`${s3baseUrl}/face-closeup-greyscale.png`, asImage)
  },
  getStarted: () => {
    preload(`${s3baseUrl}/studio-makeup-green-gold-cropped.jpg`, asImage)
    preload(`${s3baseUrl}/studio-makeup-red-lipstick-hand-cropped.jpg`, asImage)
    preload(`${s3baseUrl}/studio-makeup-lip-gloss-shoulder-cropped.jpg`, asImage)
  },
}
